import { memo, useState } from 'react';
import CountUp from 'react-countup';
import TotalFos from '../../assets/images/Reports/TotalFos.png'
import ApprovedFos from '../../assets/images/Reports/ApprovedFos.png'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import GateIN from '../../assets/images/Reports/gate-in.png'
import GateOut from '../../assets/images/Reports/gate-out.png'
import WindBarb from 'highcharts/modules/windbarb';
import TrackingChart from './TrackingChart.js'

const ReportCounters = (props) => {
    const counterOptions = [
        { label: "Total FO Numbers", value: "total_fo_numbers" },
        { label: "Approved FO Numbers", value: "approved_fo_numbers" },
        { label: "Tracking Mode", value: "tracking_mode" },
        { label: "GPS Mode", value: "gps_mode_count" },
        { label: "SIM Mode", value: "sim_mode_count" },
        { label: "Events Pushed", value: "event_pushed_count" },
        { label: "Super Tracking Count", value: "super_tracking_count" },
        { label: "Super Tracking %", value: "super_tracking_percentage" },
        { label: "Gate In", value: "gate_in_count" },
        { label: "Gate Out", value: "gate_out_count" },
        { label: "Dealer In", value: "dealer_in_count" },
        { label: "Dealer Out", value: "dealer_out_count" },
        {label :"Previous Month" , value :'previousMonth'},
        {label :"Current Month" , value :'currentMonth'}
    ];
    const defaultState = {
        totalFos: "show-n",
        approvedFos: "show-n",
        trackingMode: "show-n",
        events: "show-n",
        superTrackingCount: "show-n",
        gateIn: "show-n",
        gateOut: "show-n",
        dealerIn: "show-n",
        dealerOut: "show-n",
      };
    const [sectionVisibility, setSectionVisibility] = useState(defaultState);   
    const [isSimClicked, setIsSimClicked] = useState(false);
    const [isGpsClicked, setIsGpsClicked] = useState(false);
    const [approvedCounter,setApprovedCounter] =useState(false);
      const visibilityConfig = {
        TotalFos: {
          ...defaultState,
          totalFos: "show-m",
          eventCounter :false,
          approvedFos :'show-n',
        },
        ApprovedFos: {
          ...defaultState,
          approvedFos: "show-m",
          trackingMode :'show-m'
        },
        TrackingMode: {
          ...defaultState,
          trackingMode: "show-m",
          approvedFos : "show-m"
        },
        SIM: {
          ...defaultState,
          trackingMode: "show-m",
          approvedFos: "show-m",
        },
        GPS: {
          ...defaultState,
          approvedFos: "show-m",
          trackingMode: "show-m",
          isGpsClicked: true,
        },
        EventsPushed: {
          ...defaultState,
          approvedFos: "show-m",
          events: "show-m",
          gateIn: "show-m",
          eventCounter: true,
        },
        SuperTrackingCount: {
          ...defaultState,
          approvedFos: "show-m",
          superTrackingCount: "show-m",
        },
        GateIn: {
          ...defaultState,
          approvedFos: "show-m",
          events: "show-m",
          gateIn: "show-m",
          eventCounter: true,
        },
        GateOut: {
          ...defaultState,
          approvedFos: "show-m",
          events: "show-m",
          gateOut: "show-m",
          eventCounter: true,
        },
        DealerIn: {
          ...defaultState,
          approvedFos: "show-m",
          events: "show-m",
          dealerIn: "show-m",
          eventCounter: true,
        },
        DealerOut: {
          ...defaultState,
          approvedFos: "show-m",
          events: "show-m",
          dealerOut: "show-m",
          eventCounter: true,
        },
      };
      const setCounterData = (activeTab) => {
        const config = visibilityConfig[activeTab];
        if (activeTab === "ApprovedFos") {
          setSectionVisibility(prev => {
            const isCurrentlyVisible = prev.approvedFos === "show-m";
            setApprovedCounter(!isCurrentlyVisible);
            return {
              ...defaultState,
              approvedFos: isCurrentlyVisible ? "show-n" : "show-m",
              trackingMode: isCurrentlyVisible ? "show-n" : "show-m",
            };
          });
          return; // Exit early to avoid other logic
        }
        if (activeTab === "EventsPushed") {
            setSectionVisibility(prev => {
              const isVisible = prev.events === "show-m";
              return {
                ...defaultState,
                approvedFos: isVisible ? "show-n" : "show-m",
                events: isVisible ? "show-n" : "show-m",
                gateIn: isVisible ? "show-n" : "show-m",
                eventCounter: !isVisible
              };
            });
            return;
          }
        if (config) {
          setSectionVisibility(config);
        }
        if (activeTab === "TotalFos") {
          setApprovedCounter(false);
        }
        if (activeTab === "SIM") {
          setIsSimClicked(true);
          setIsGpsClicked(false);
        } else if (activeTab === "GPS") {
          setIsSimClicked(false);
          setIsGpsClicked(true);
        } else {
          setIsSimClicked(false);
        }
      };
            
    const {
        totalFos,
        approvedFos,
        trackingMode,
        eventCounter,
        events,
        superTrackingCount,
        gateIn,
        gateOut,
        dealerIn,
        dealerOut,
      } = sectionVisibility;
    return (
        <>
        <div className="row" style={{width:'102%'}}>
        <div className="col-xl-12 col-lg-12 col-sm-12 beffect">
                <div className="card" style={{ }}>
                    <div className="card-body" id="counterCardBody">
                           <div className='row'>
                           <div className="col report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[0].value);  setCounterData("TotalFos")}}>
                            <div className={(totalFos == "show-m" ? 'background-report':'report-cell')} >
                              <img src={TotalFos}/>
                                            <div className='report-counter'><span className={"f18 " + (totalFos == 'show-m'  ? 'fbold-report blackColor' : '')} id='fos-name'><br /> Total FO Numbers</span>
                                            <h4 className="txt-pink-medium f22"><span className="counter" id='fos-name'><CountUp end={props?.total_fo_numbers ? props.total_fo_numbers : 0} /></span></h4>
                                            </div>
                                            </div>
                                            <span className={"downpointer-report-maincounters " + (totalFos)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                           <div className="col report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[1].value); setCounterData("ApprovedFos");}}>
                            <div className={approvedFos == 'show-m' ? 'approved-background':'report-cell'}>
                              <img src={ApprovedFos}/>
                                            <div className='report-counter'><span className={"f18 " + (approvedFos == 'show-m'  ? 'fbold-report blackColor' : '')} id='approved-Fos'><br /> Approved FO Numbers</span>
                                            <h4 className="txt-secondary f22"><span className="counter" id='approved-Fos'><CountUp end={props?.approved_fo_numbers ? props.approved_fo_numbers : 0} /></span></h4>
                                            </div></div>
                                            <span className={"downpointer-report-maincounters " + (approvedFos)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                           </div> 
                    </div>
                </div>
                {approvedCounter  &&(<div className="card-report" style={{ }}>
                    <div className="card-body" id="approvedCounterCardBody">
                           <div className='row'>
                                <div className="col 4 report-cursorPointer" onClick={() => {props?.setCounter(counterOptions[2].value); setCounterData("TrackingMode");setIsGpsClicked(false);setIsSimClicked(false)}}>
                                    <div className='trackingMode'><span className={"f16 " + (trackingMode == 'show-m' ? 'fbold-report blackColor' : '')} style={{marginRight:'30px'}}><br /> Tracking Modes</span>
                                    <span className={(trackingMode =="show-m"? 'fbold-report-count':'counter-tracking')}><CountUp end={props?.tracking_mode ? props.tracking_mode : 0} /></span></div>
                                    <div className="row-report">
                                        {/* GPS */}
                                        <div
                                            className="col report-cursorPointer"
                                            onClick={(e) => {e.stopPropagation(); props?.setCounter(counterOptions[3].value); setCounterData("GPS"); setIsSimClicked(false);setIsGpsClicked(true);}} style={{ fontWeight: isGpsClicked ? "bold" : "100" }} >
                                            <span className={ "gps-counter"}>GPS</span>
                                            <div className="gps-counter">
                                                <span className={"counter" + "gps-counter"}>
                                                    <CountUp end={props?.gps_mode_count ? props?.gps_mode_count : 0} />
                                                </span>
                                            </div>
                                        </div>
                                        {/* SIM */}
                                        <div
                                            className="col report-cursorPointer"
                                            onClick={(e) => {e.stopPropagation(); props?.setCounter(counterOptions[4].value);setCounterData("SIM");setIsSimClicked(true);setIsGpsClicked(false);}}style={{ fontWeight: isSimClicked ? "bold" : "100" }}>
                                            <span className="sim-counter">SIM</span>
                                            <div className="sim-counter"><span className={"counter" + "sim-counter"}><CountUp end={props?.sim_mode_count ? props?.sim_mode_count : 0} /></span></div>
                                        </div>
                                    </div>
                                    <span className={"downpointer-report " + trackingMode}>
                                        <i className="fa fa-caret-down"></i>
                                    </span>
                                </div>

                           <div className="col 2 report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[5].value); setCounterData("EventsPushed") ;setIsGpsClicked(false) ; setIsSimClicked(false)}}>
                                            <div className='eventsPushed'>
                                            <span className={"f16 " + (events == 'show-m'  ? 'fbold-report blackColor' : '')}><br /> Events Pushed</span>
                                            <h4 className="font-color-yellow f20" id='font-font-report-yellow'><span className="counter"><CountUp end={props?.event_pushed_count ? props.event_pushed_count : 0} /></span></h4></div>
                                            <span className={"downpointer-report " + (events)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                            
                                        </div>
                           <div className="col 2 report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[6].value); setCounterData("SuperTrackingCount") ; setIsGpsClicked(false);setIsSimClicked(false) }}>
                                            <div className='superTracking'><span className={"f16 " + (superTrackingCount == 'show-m'  ? 'fbold-report blackColor' : '')}><br /> Super Tracking Count</span>
                                            <div className='super_tracking_counter'>
                                            <h4 className="binfo f20" ><span className="counter"><CountUp end={props?.super_tracking_count ? props?.super_tracking_count : 0} /></span></h4>
                                            <h6 className='binfo'id='superper' ><span >({(props?.super_tracking_count / props?.approved_fo_numbers)*100 ? ((props?.super_tracking_count / props?.approved_fo_numbers)*100).toFixed(2)  : 0}%) </span></h6></div></div>
                                            <span className={"downpointer-report " + (superTrackingCount)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                           <div className="col 4" onClick={(e) => { props?.setCounter(counterOptions[7].value); setCounterData("TrackingPercentage") }}>
                                    <div id="chart-wrapper">
                                      <TrackingChart  previous={props?.[counterOptions[12].value]} current= {props?.[counterOptions[13].value]}/>
                                    </div>
                                    </div>
                           </div>

                    </div>
                </div>) }
                {eventCounter  &&(<div className="card-report" style={{ }}>
                    <div className="card-body" id="counterCardBody">
                           <div className='row'>
                           <div className="col report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[8].value);  setCounterData("GateIn")}}>
                                            <div className='event-counters' ><img src={GateIN} className='event-img'/>
                                            <div><span className={"f16 " + (gateIn == 'show-m'  ? 'fbold-report blackColor' : '')}><br /> Gate In</span>
                                            <h4 className="gateIn f22"><span className="counter"><CountUp end={props?.gate_in_count ? props.gate_in_count : 0} /></span></h4></div></div>
                                            <span className={"downpointer-report-eventcounters " + (gateIn)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                           <div className="col report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[9].value); setCounterData("GateOut") }}>
                           <div className='event-counters'><img src={GateOut} className='event-img'/>
                           <div> <span className={"f16 " + (gateOut == 'show-m'  ? 'fbold-report blackColor' : '')}><br /> Gate Out</span>
                                            <h4 className="gateOut f22"><span className="counter"><CountUp end={props?.gate_out_count ? props.gate_out_count : 0} /></span></h4></div>
                                            </div><span className={"downpointer-report-eventcounters " + (gateOut)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                           <div className="col report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[10].value); setCounterData("DealerIn") }}>
                                           <div className='event-counters'><img src={GateIN} className='event-img'/>
                                           <div> <span className={"f16 " + (dealerIn == 'show-m'  ? 'fbold-report blackColor' : '')}><br /> Dealer In</span>
                                            <h4 className="gateIn f22"><span className="counter"><CountUp end={props?.dealer_in_count ? props.dealer_in_count : 0} /></span></h4></div>
                                           </div> <span className={"downpointer-report-eventcounters " + (dealerIn)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                           <div className="col report-cursorPointer" onClick={(e) => { props?.setCounter(counterOptions[11].value); setCounterData("DealerOut") }}>
                                            <div className='event-counters'><img src={GateOut} className='event-img'/>
                                            <div><span className={"f16 " + (dealerOut == 'show-m'  ? 'fbold-report blackColor' : '')}><br />Dealer Out</span>
                                            <h4 className="gateOut f22"><span className="counter"><CountUp end={props?.dealer_out_count ? props.dealer_out_count : 0} /></span></h4></div>
                                            </div><span className={"downpointer-report-eventcounters " + (dealerOut)}>
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                           </div>

                    </div>
                </div>) }
            </div>
            </div>
        </>
    );
};

export default memo(ReportCounters);
